import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map, switchMap, catchError, take } from 'rxjs/operators';
import { v4 as newGuid } from 'uuid';
import { MaintenanceService } from '../services/maintenance.service';
import { AuthService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(
    private maintenanceService: MaintenanceService,
    private auth: AuthService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    try {
      // First set basic headers like Transaction-Id
      request = request.clone({
        setHeaders: {
          'Transaction-Id': newGuid()
        },
        url: request.url.replace('#', '%23')
      });

      // Get token from AuthService and attach to the request
      return this.auth.getAccessToken$().pipe(
        take(1),
        switchMap(token => {
          
          // If token exists, add it to the authorization header
          if (token) {
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            });
          }
          
          return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
              if (event instanceof HttpResponse) {
                let headers = event.headers.keys();
                if (headers.includes('trs-maintenance')) {
                  this.enableMaintenance();
                }
              }
              return event;
            })
          );
        }),
        catchError(err => {
          // If token retrieval fails, proceed with the request without the token
          console.error('Error getting access token', err);
          return next.handle(request);
        })
      );
    } catch (error) {
      console.error(error);
      return next.handle(request);
    }
  }

  enableMaintenance() {
    if (!this.maintenanceService.maintenance.getValue()) {
      this.maintenanceService.setMaintenance(true);
    }
  }
}